import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Loading from 'components/system/Loading/Loading';
import colors from 'styles/colors';

const JobNotebookStartingNote = () => (
  <Box
    style={{
      height: 'calc(100% - 2px)',
      marginLeft: '3px',
      overflowX: 'hidden',
      overflowY: 'hidden',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Box style={{ textAlign: 'center' }}>
      <Button
        disabled
        variant="contained"
        type="primary"
      >
        Start the Notebook
      </Button>
      <Typography
        sx={{
          display: 'block',
          color: colors.text.primary,
          paddingTop: '15px',
          paddingBottom: '15px',
        }}
        variant="buttonLarge"
      >
        It might take 1-2 minutes to start the machine. Please wait.
      </Typography>
      <Loading />
    </Box>
  </Box>
);

export default JobNotebookStartingNote;
